export const BASE_EDITOR_HEIGHT = 69;
export const METADATA_BAR_HEIGHT = 49;
export const EDITOR_MARGIN = 16;